export default function HowItWorksSection() {
  const details = [
    {
      icon: 'ri-time-line',
      title: 'Duração',
      value: '4 horas de experiência',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-map-pin-2-line',
      title: 'Formato',
      value: 'Presencial e altamente prático',
      color: 'from-green-500 to-green-600'
    },
    {
      icon: 'ri-building-line',
      title: 'Ambiente',
      value: 'Treinamento profissional',
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: 'ri-group-line',
      title: 'Dinâmica',
      value: 'Exercícios, prática e interação',
      color: 'from-orange-500 to-orange-600'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Objetivo',
      value: 'Desbloquear sua comunicação',
      color: 'from-red-500 to-red-600'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header elegante */}
        <div className="text-center mb-12">
          <div className="inline-block mb-4">
            <span className="text-sm font-semibold text-gray-500 uppercase tracking-wider">Detalhes do Evento</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Como funciona o <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#F19E1A] to-[#e08d0f]">evento</span>
          </h2>
          <p className="text-lg text-gray-600">
            Tudo que você precisa saber sobre o VoxDay
          </p>
        </div>

        {/* Cards minimalistas e sofisticados */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {details.map((detail, index) => (
            <div 
              key={index}
              className="group relative bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1 overflow-hidden border border-gray-200"
            >
              {/* Header compacto com gradiente */}
              <div className={`bg-gradient-to-br ${detail.color} p-4 text-white relative overflow-hidden`}>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center backdrop-blur-sm">
                    <i className={`${detail.icon} text-2xl`}></i>
                  </div>
                  <h3 className="text-lg font-bold">{detail.title}</h3>
                </div>
              </div>
              
              {/* Conteúdo */}
              <div className="p-4">
                <p className="text-sm text-gray-700">
                  {detail.value}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA final compacto e elegante */}
        <div className="relative max-w-4xl mx-auto">
          <div className="absolute inset-0 bg-gradient-to-r from-[#F19E1A]/20 to-[#e08d0f]/20 blur-2xl"></div>
          <div className="relative bg-gradient-to-r from-[#F19E1A] to-[#e08d0f] rounded-2xl p-8 text-center shadow-xl">
            <div className="flex items-center justify-center gap-3 mb-2">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                <i className="ri-lightbulb-flash-line text-white text-2xl"></i>
              </div>
              <p className="text-xl md:text-2xl font-bold text-white">
                Uma experiência imersiva e transformadora
              </p>
            </div>
            <p className="text-base text-white/90">
              Prepare-se para sair do VoxDay com uma <strong className="text-white">nova visão</strong> sobre sua capacidade de comunicação.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
